import { useEffect, useState } from 'react';
import ModalComponent from '../../../component/modal/modal';
import {
  initializeFormValues,
  renderCreationForm,
  renderReviewFields,
} from '../../../component/userModal/helper';
import {
  AddOrganisationModalProps,
  AddOrganizationUnitResponse,
  AddOrganizationUnitResponseStatus,
  VenuesViewAddOptions,
} from './venuesView.type';
import { FieldConfig } from '../../../strategies/userPresentation/userPresentationStrategy.interface';
import { Trans, useTranslation } from 'react-i18next';
import { modalHeader } from './venuesViewHelper';
import { useOrganizationContext } from '../../../service/context/organizationContext';
import {
  AddOrganizationParams,
  useAddOrganizationUnit,
} from '../../../hooks/useUserData';
import { OrganizationUnitType, UserType } from '@inplay/models';
import { Option } from '../../../component/dropDownInput/dropDownInput.type';
import { useUserDetailContext } from '../../../service/context/userDetailContext';
import UniversalStaffLogin from '../../../pages/onboarding/venuSetup/universalStaffLogin';
import { VenueBranch } from '../../../pages/onboarding/venuSetup/type';
import { AuthService } from '../../../service/authService';
import { route } from '../../../service/router';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../../component/confirmationModal/confirmationModal';
import { toast } from 'react-toastify';
import { UserService } from '../../../service/userService';
import { StorageKey } from '../../../utils/helper.type';
import {
  OrganizationFormValue,
  OrganizationFormValues,
} from '../userManagement.type';

const AddOrganisationModal = (props: AddOrganisationModalProps) => {
  const [formFields, setFormFields] = useState<FieldConfig[]>([]);
  const [formValues, setFormValues] = useState<Record<string, string | number>>(
    {},
  );
  const [errorMessage, setErrorMessage] = useState<Record<string, string>>({});
  const [showCreate, setShowCreate] = useState<boolean>(false);
  const [showCreateUserLoading, setShowCreateUserLoading] =
    useState<boolean>(false);
  const [showUniversalStaffSetup, setShowUniversalStaffSetup] =
    useState<boolean>(false);
  const [
    showUniversalStaffLoginReviewModal,
    setShowUniversalStaffLoginReviewModal,
  ] = useState<boolean>(false);
  const [showConfirmationModalOnCancel, setShowConfirmationModalOnCancel] =
    useState(false);
  const [showConfirmationModalOnContinue, setShowConfirmationModalOnContinue] =
    useState(false);
  const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
  const [emailsSent, setEmailsSent] = useState<
    Array<{ email: string; userId: string }>
  >([]);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [formValuesByType, setFormValuesByType] = useState<
    Record<string, OrganizationFormValues>
  >({});

  const [branchDetails, setBranchDetails] = useState<VenueBranch>({
    id: '',
    name: '',
    hasUniversalLogin: false,
    email: '',
    password: '',
    verificationCode: '',
    confirmPassword: '',
  });

  const { organizationSummary, fetchOrganizationSummary } =
    useOrganizationContext();
  const { userDetail } = useUserDetailContext();
  const { addOrgUnit, addOrgUnitLoading } = useAddOrganizationUnit();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const gamblingOptions: Option[] = [
    ...Array.from({ length: 18 }, (_, index: number) => ({
      value: index.toString(),
      label: index.toString(),
    })),
    { value: '18+', label: '18+' },
  ];

  useEffect(() => {
    const options: Option[] =
      organizationSummary
        ?.filter((org) => org.type === OrganizationUnitType.SUB_ORGANIZATION)
        ?.map((org) => ({ label: org.name, value: org._id })) || [];

    const allowedVenue = JSON.parse(
      localStorage.getItem(StorageKey.VENUE_UNIT_DETAILS) || '{}',
    )?.venue;

    const venueOptions: Option[] =
      userDetail?.type === UserType.VENUE_ADMIN ||
      userDetail?.type === UserType.VENUE_MANAGER
        ? [{ label: allowedVenue?.name, value: allowedVenue?.id }]
        : organizationSummary
            ?.filter((org) => org.type === OrganizationUnitType.VENUE)
            ?.map((org) => ({ label: org?.name, value: org?._id })) || [];

    if (props.type === VenuesViewAddOptions.ADD_SUB_ORGANISATION) {
      setFormFields([
        {
          id: 'subOrganisation',
          label: `${t('userManagement.userVenue.subOrganization')}${
            showCreate ? '' : '*'
          }`,
          type: 'text',
          required: true,
          placeholder: t('userManagement.userVenue.commonPlaceHolder'),
          disabled: showCreate,
        },
      ]);
    } else if (props.type === VenuesViewAddOptions.ADD_VENUE) {
      if (userDetail?.type === UserType.SUB_ORGANIZATION_ADMIN) {
        setFormFields([
          {
            id: 'subOrganisation',
            label: `${t('userManagement.userVenue.subOrganization')}${
              showCreate ? '' : '*'
            }`,
            type: 'dropdown',
            required: true,
            placeholder: t('userManagement.userVenue.selectSubOrganization'),
            options: options,
            disabled: true,
            defaultValue: userDetail?.subOrganizations
              ? userDetail?.subOrganizations[0]?.id
              : '',
          },
          {
            id: 'venue',
            label: `${t('userManagement.userVenue.venue')}${
              showCreate ? '' : '*'
            }`,
            type: 'text',
            required: true,
            placeholder: t('userManagement.userVenue.commonPlaceHolder'),
            disabled: showCreate,
          },
          {
            id: 'venueBranch',
            label: `${t('userManagement.userVenue.venueBranch')}${
              showCreate ? '' : '*'
            }`,
            type: 'text',
            required: true,
            placeholder: t('userManagement.userVenue.venueBranchPlaceHolder'),
            disabled: showCreate,
          },
        ]);
      } else {
        setFormFields([
          {
            id: 'subOrganisation',
            label: `${t('userManagement.userVenue.subOrganization')}${
              showCreate ? '' : '*'
            }`,
            type: 'dropdown',
            required: true,
            placeholder: t('userManagement.userVenue.selectSubOrganization'),
            options: options,
            disabled: showCreate,
          },
          {
            id: 'venue',
            label: `${t('userManagement.userVenue.venue')}${
              showCreate ? '' : '*'
            }`,
            type: 'text',
            required: true,
            placeholder: t('userManagement.userVenue.commonPlaceHolder'),
            disabled: showCreate,
          },
          {
            id: 'venueBranch',
            label: `${t('userManagement.userVenue.venueBranch')}${
              showCreate ? '' : '*'
            }`,
            type: 'text',
            required: true,
            placeholder: t('userManagement.userVenue.venueBranchPlaceHolder'),
            disabled: showCreate,
          },
          {
            id: 'gamblingMachine',
            label: `${t('userManagement.userVenue.noOfGamblingMachine')}${
              showCreate ? '' : ' *'
            }`,
            type: 'dropdown',
            required: true,
            placeholder: t('userManagement.userVenue.noOfGambling'),
            options: gamblingOptions,
            disabled: false,
          },
        ]);
      }
    } else if (props.type === VenuesViewAddOptions.ADD_VENUE_BRANCH) {
      const isVenueAdminOrManager =
        userDetail?.type === UserType.VENUE_ADMIN ||
        userDetail?.type === UserType.VENUE_MANAGER;

      const fields: FieldConfig[] = [];

      // Add sub-organization field only if not Venue Admin/Manager
      if (!isVenueAdminOrManager) {
        fields.push({
          id: 'subOrganisation',
          label: `${t('userManagement.userVenue.subOrganization')}${
            showCreate ? '' : '*'
          }`,
          type: 'dropdown' as const,
          required: false,
          placeholder: t('userManagement.userVenue.selectSubOrganization'),
          options: options,
          disabled: showCreate,
        });
      }

      // Always add venue and venue branch fields
      fields.push(
        {
          id: 'venue',
          label: `${t('userManagement.userVenue.venue')}${
            showCreate ? '' : '*'
          }`,
          defaultValue:
            userDetail?.type === UserType.VENUE_ADMIN ||
            userDetail?.type === UserType.VENUE_MANAGER
              ? venueOptions[0]?.value
              : '',
          type: 'dropdown' as const,
          required: true,
          placeholder: t('userManagement.userVenue.selectVenue'),
          options: venueOptions,
          disabled:
            userDetail?.type === UserType.VENUE_ADMIN ||
            userDetail?.type === UserType.VENUE_MANAGER
              ? true
              : showCreate,
        },
        {
          id: 'venueBranch',
          label: `${t('userManagement.userVenue.venueBranch')}${
            showCreate ? '' : '*'
          }`,
          type: 'text' as const,
          required: true,
          placeholder: 'e.g. Avonhead',
          disabled: showCreate,
        },
        {
          id: 'gamblingMachine',
          label: `${t('userManagement.userVenue.noOfGamblingMachine')}${
            showCreate ? '' : ' *'
          }`,
          type: 'dropdown',
          required: true,
          placeholder: t('userManagement.userVenue.noOfGambling'),
          options: gamblingOptions,
          disabled: false,
        },
      );

      setFormFields(fields);
    }
  }, [props.type, showCreate, organizationSummary, userDetail]);

  useEffect(() => {
    if (formFields.length > 0) {
      const existingFormValue: OrganizationFormValues =
        formValuesByType[props.type];
      setFormValues(existingFormValue ?? initializeFormValues(formFields));
    }
  }, [formFields, props.type]);

  const validateForm = () => {
    const errors: Record<string, string> = {};
    formFields.forEach((fieldConfig: FieldConfig) => {
      if (fieldConfig.required && !formValues[fieldConfig.id]) {
        errors[fieldConfig.id] = `${fieldConfig.label} is required`;
      }
    });
    setErrorMessage(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (field: string, value: OrganizationFormValue): void => {
    setFormValues(
      (previousFormValue: OrganizationFormValues): OrganizationFormValues => {
        const updated: OrganizationFormValues = {
          ...previousFormValue,
          [field]: value,
        };

        setFormValuesByType(
          (
            previousFormValuesByType: Record<string, OrganizationFormValues>,
          ) => ({
            ...previousFormValuesByType,
            [props.type]: updated,
          }),
        );

        return updated;
      },
    );

    setErrorMessage({});
  };

  const handleNext = async () => {
    const validated: boolean = validateForm();
    if (validated) {
      if (props.type === VenuesViewAddOptions.ADD_VENUE_BRANCH) {
        if (showUniversalStaffSetup) {
          // for the second modal when user is either venue admin or venue manager creating venueBranch &&  user is creating universal staff login
          const hasOtherVerifiedEmails =
            emailsSent?.length &&
            emailsSent?.some((item) => item.email !== branchDetails?.email);
          if (hasOtherVerifiedEmails) {
            setShowConfirmationModalOnContinue(true);
          } else {
            setShowUniversalStaffSetup(false);
            setShowUniversalStaffLoginReviewModal(true);
          }
        } else if (
          userDetail?.type === UserType.VENUE_ADMIN ||
          userDetail?.type === UserType.VENUE_MANAGER
        ) {
          // for the first modal when user is either venue admin or venue manager creating venueBranch
          try {
            const payload = {
              name: formValues.venueBranch as string,
              venueId: formValues.venue.toString(),
              type: OrganizationUnitType.VENUE_BRANCH,
            };
            if (payload) {
              const addResponse: AddOrganizationUnitResponse | undefined =
                await addOrgUnit(payload);
              if (
                addResponse &&
                addResponse.statusCode ===
                  AddOrganizationUnitResponseStatus.SUCCESS
              ) {
                setBranchDetails({
                  ...branchDetails,
                  id: addResponse.data.organizationUnitId,
                  name: formValues.venueBranch as string,
                });
                setShowUniversalStaffSetup(true);
              }
            }
          } catch (error: any) {
            console.error('Error creating venue branch:', error);
            toast.error(t(`${error?.response?.data?.message}`));
          } finally {
            setShowCreateUserLoading(false);
          }
        } else {
          setShowCreate(true);
        }
      } else {
        setShowCreate(true);
      }
    }
  };

  const handleSaveUniversalStaffLogin = async () => {
    setShowCreateUserLoading(true);
    try {
      const authService = new AuthService();
      await authService.newPassword(
        branchDetails?.email,
        branchDetails?.password,
        branchDetails?.verificationCode,
      );
      setShowCreate(true);
      setShowUniversalStaffSetup(false);
      props.onToggle(false);
      navigate(route.userManagement, {
        state: { showVenueBranchCreatedToast: true },
      });
    } catch (error: any) {
      console.error('Error creating universal staff login:', error);
      toast.error(t(`${error?.response?.data?.message}`));
    } finally {
      setShowCreateUserLoading(false);
    }
  };

  const handleCreate = async () => {
    let payload: AddOrganizationParams | undefined = undefined;
    if (props.type === VenuesViewAddOptions.ADD_SUB_ORGANISATION) {
      const organizationId: string | undefined = organizationSummary?.filter(
        (org) => org.type === OrganizationUnitType.ORGANIZATION,
      )[0]._id;
      if (organizationId) {
        payload = {
          name: formValues.subOrganisation as string,
          organizationId,
          type: OrganizationUnitType.SUB_ORGANIZATION,
        };
      }
    } else if (props.type === VenuesViewAddOptions.ADD_VENUE) {
      payload = {
        name: formValues.venue as string,
        subOrganizationIds: [formValues.subOrganisation.toString()],
        type: OrganizationUnitType.VENUE,
        venueBranchName: formValues.venueBranch as string,
        numberOfGamblingMachines: formValues.gamblingMachine as string,
      };
    }

    if (props.type === VenuesViewAddOptions.ADD_VENUE_BRANCH) {
      if (showUniversalStaffLoginReviewModal) {
        // for the review modal when user is either venue admin or venue manager after creating venueBranch & verify universal staff login email
        await handleSaveUniversalStaffLogin();
      } else {
        payload = {
          name: formValues.venueBranch as string,
          venueId: formValues.venue.toString(),
          type: OrganizationUnitType.VENUE_BRANCH,
          numberOfGamblingMachines: formValues.gamblingMachine as string,
        };
      }
    }
    try {
      if (payload) {
        setShowCreateUserLoading(true);
        const addResponse: AddOrganizationUnitResponse | undefined =
          await addOrgUnit(payload);
        if (
          addResponse &&
          addResponse.statusCode === AddOrganizationUnitResponseStatus.SUCCESS
        ) {
          fetchOrganizationSummary();
          if (
            props.type === VenuesViewAddOptions.ADD_VENUE_BRANCH &&
            !showUniversalStaffLoginReviewModal
          ) {
            setBranchDetails({
              ...branchDetails,
              id: addResponse.data.organizationUnitId,
              name: formValues.venueBranch as string,
            });
          } else {
            navigate(route.userManagement, {
              state: { showVenueBranchCreatedToast: true },
            });
          }
          props.onToggle(false);
        }
        setShowCreateUserLoading(false);
      }
    } catch (error: any) {
      console.error('Error creating venue branch:', error);
      toast.error(t(`${error?.response?.data?.message}`));
    } finally {
      setShowCreateUserLoading(false);
    }
  };

  const handleCancel = () => {
    if (
      (showUniversalStaffSetup && emailsSent?.length) ||
      showUniversalStaffLoginReviewModal
    ) {
      setShowConfirmationModalOnCancel(true);
    } else {
      props.onToggle(false);
    }
  };

  const handleBackButton = () => {
    if (showUniversalStaffLoginReviewModal) {
      setShowUniversalStaffLoginReviewModal(false);
      setShowUniversalStaffSetup(true);
    } else if (showCreate) {
      setShowCreate(false);
    }
  };

  const handleBranchChange = (
    branchId: string,
    field: 'email' | 'password' | 'verificationCode' | 'confirmPassword',
    value: string,
  ) => {
    setBranchDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleEmailChange = (branchId: string, value: string) => {
    setBranchDetails((prev) => ({
      ...prev,
      email: value,
    }));
  };

  const updateEmailSent = (branchId: string, email: string, userId: string) => {
    setEmailsSent((prev) => [...prev, { email, userId }]);
  };

  const modalHeaderTitle: string = showUniversalStaffSetup
    ? t('userManagement.setUniversalStaffLogin')
    : showUniversalStaffLoginReviewModal
      ? t('userManagement.review')
      : props.type === VenuesViewAddOptions.ADD_SUB_ORGANISATION
        ? 'userManagement.addSubOrgTitle'
        : props.type === VenuesViewAddOptions.ADD_VENUE
          ? 'userManagement.addVenueTitle'
          : 'userManagement.addVenueBranchTitle';

  const handleDeleteUniversalStaffLoginUser = async () => {
    setIsLoading(true);
    try {
      const userService = new UserService();

      // Get all emails that need to be deleted (all emails that have been sent verification codes)
      const hasVerifiedEmails = emailsSent?.length;

      if (!hasVerifiedEmails) {
        toast.error(t('venueSetup.verificationCodeNotSent'));
        return;
      }

      // Delete users based on confirmation modal state
      if (showConfirmationModalOnContinue) {
        // Delete all users except current branch email
        const usersToDelete = emailsSent
          ?.filter((item) => item.email !== branchDetails?.email)
          ?.map((item) => item.userId);
        await userService.deleteUser(usersToDelete);
        if (usersToDelete?.length > 1) {
          toast.success(t('universalStaffLoginModal.usersDeleted'));
        } else {
          toast.success(t('universalStaffLoginModal.userDeleted'));
        }
        // Clear email sent state for all deleted users
        setEmailsSent([
          emailsSent.find((item) => item.email === branchDetails?.email) ?? {
            email: branchDetails?.email ?? '',
            userId: '',
          },
        ]);
        setShowUniversalStaffSetup(false);
        setShowUniversalStaffLoginReviewModal(true);
        setShowConfirmationModalOnContinue(false);
      } else if (showConfirmationModalOnCancel) {
        // Delete all users
        const usersToDelete = emailsSent?.map((item) => item.userId);
        await userService.deleteUser(usersToDelete);
        if (usersToDelete?.length > 1) {
          toast.success(t('universalStaffLoginModal.usersDeleted'));
        } else {
          toast.success(t('universalStaffLoginModal.userDeleted'));
        }
        setEmailsSent([]);
        props.onToggle(false);
      }
    } catch (error) {
      console.error('Error deleting users:', error);
      toast.error(t('venueSetup.errorDeletingUser'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ModalComponent
      open={props.show}
      onToggle={props.onToggle}
      title={
        showUniversalStaffSetup
          ? modalHeaderTitle
          : modalHeader(
              modalHeaderTitle,
              showUniversalStaffLoginReviewModal || showCreate,
              handleBackButton,
            )
      }
      dialogClassName="top-[100px] right-[0px] w-[600px]"
      modalClassName="h-[calc(100vh-100px)]"
      showFooter1Button
      showFooter2Button
      footerButton1Text="Cancel"
      footerButton2Text={
        showCreate || showUniversalStaffLoginReviewModal ? 'Create' : 'Next'
      }
      onFooterButton1Click={handleCancel}
      onFooterButton2Click={
        showCreate || showUniversalStaffLoginReviewModal
          ? handleCreate
          : handleNext
      }
      disableFooter1Button={addOrgUnitLoading}
      disableFooter2Button={
        (showUniversalStaffSetup && nextButtonDisabled) ||
        (props.type === VenuesViewAddOptions.ADD_VENUE_BRANCH &&
          formFields.some((field) => field.required && !formValues[field.id]))
      }
      showCreateUserLoading={showCreateUserLoading || addOrgUnitLoading}
    >
      <>
        {showUniversalStaffLoginReviewModal ? (
          renderReviewFields(
            formFields,
            formValues,
            true,
            showPassword,
            setShowPassword,
            branchDetails?.password,
          )
        ) : showUniversalStaffSetup ? (
          <>
            <div className="text-[#1A1A1A] text-[12px] mb-4">
              <Trans
                i18nKey={'userManagement.universalStaffLoginDescription'}
              />
            </div>
            <UniversalStaffLogin
              branch={branchDetails}
              handleBranchChange={handleBranchChange}
              enableContinueButton={() => {
                setNextButtonDisabled(false);
              }}
              venueId={formValues.venue.toString()}
              emailsSent={emailsSent}
              updateEmailSent={updateEmailSent}
              handleEmailChange={handleEmailChange}
            />
          </>
        ) : (
          <>
            {showCreate ? (
              <>
                {props.type === VenuesViewAddOptions.ADD_SUB_ORGANISATION ? (
                  <>
                    <div className="text-[#1A1A1A] text-[12px]">
                      <Trans i18nKey={'userManagement.createSubOrgText'} />
                    </div>
                    {renderReviewFields(formFields, formValues)}
                  </>
                ) : props.type === VenuesViewAddOptions.ADD_VENUE ? (
                  <>
                    <div className="text-[#1A1A1A] text-[12px]">
                      <Trans i18nKey={'userManagement.createVenueText'} />
                    </div>
                    {renderReviewFields(formFields, formValues)}
                  </>
                ) : props.type === VenuesViewAddOptions.ADD_VENUE_BRANCH ? (
                  <>
                    <div className="text-[#1A1A1A] text-[12px]">
                      <Trans i18nKey={'userManagement.createVenueBranchText'} />
                    </div>
                    {renderReviewFields(formFields, formValues)}
                  </>
                ) : null}
              </>
            ) : (
              <>
                <div className="text-[#1A1A1A] font-medium text-[14px]">
                  <Trans i18nKey={'userManagement.details'} />
                </div>
                {props.type === VenuesViewAddOptions.ADD_SUB_ORGANISATION ? (
                  <>
                    <div className="text-[#1A1A1A] text-[12px]">
                      <Trans i18nKey={'userManagement.addSubOrgText'} />
                    </div>
                    {renderCreationForm(
                      formFields,
                      formValues,
                      handleChange,
                      errorMessage,
                    )}
                  </>
                ) : props.type === VenuesViewAddOptions.ADD_VENUE ? (
                  <>
                    <div className="text-[#1A1A1A] text-[12px]">
                      <Trans i18nKey={'userManagement.addVenueText1'} />
                    </div>
                    {renderCreationForm(
                      formFields.slice(0, -1),
                      formValues,
                      handleChange,
                      errorMessage,
                    )}
                    <div className="text-[#1A1A1A] text-[12px] mt-3">
                      <Trans i18nKey={'userManagement.addVenueText2'} />
                    </div>
                    {renderCreationForm(
                      formFields.slice(-1),
                      formValues,
                      handleChange,
                      errorMessage,
                    )}
                  </>
                ) : props.type === VenuesViewAddOptions.ADD_VENUE_BRANCH ? (
                  <>
                    <div className="text-[#1A1A1A] text-[12px]">
                      <Trans i18nKey={'userManagement.addVenueBranchText'} />
                    </div>
                    {renderCreationForm(
                      formFields,
                      formValues,
                      handleChange,
                      errorMessage,
                    )}
                  </>
                ) : null}
              </>
            )}
          </>
        )}
        {(showConfirmationModalOnCancel || showConfirmationModalOnContinue) && (
          <ConfirmationModal
            showConfirmButton
            isOpen={
              showConfirmationModalOnCancel || showConfirmationModalOnContinue
            }
            onConfirm={handleDeleteUniversalStaffLoginUser}
            onClose={() =>
              showConfirmationModalOnCancel
                ? setShowConfirmationModalOnCancel(false)
                : setShowConfirmationModalOnContinue(false)
            }
            message={
              showConfirmationModalOnCancel
                ? t(
                    'userManagement.confirmMessageOnCancellingUniversalStaffLogin',
                  )
                : t('userManagement.confirmMessageOnNextUniversalStaffLogin')
            }
            isLoading={isLoading}
          />
        )}
      </>
    </ModalComponent>
  );
};

export default AddOrganisationModal;
